import getScenarioStore from '../store/getScenarioStore';
import { SearchScenarioId } from 'owa-search-next-common';
import { mutatorAction } from 'satcheljs';

export default mutatorAction(
    'updateSelectedSuggestionIndex',
    (scenarioId: SearchScenarioId, selectedSuggestionIndex: number) => {
        getScenarioStore(scenarioId).selectedSuggestionIndex = selectedSuggestionIndex;
    }
);
